'use client'

// ../../node_modules/@chakra-ui/icon/dist/chunk-2GBDXOMA.mjs
import {
  chakra,
  forwardRef,
  useStyleConfig
} from "@chakra-ui/system";

// ../../node_modules/@chakra-ui/shared-utils/dist/index.mjs
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// ../../node_modules/@chakra-ui/icon/dist/chunk-2GBDXOMA.mjs
import { jsx, jsxs } from "react/jsx-runtime";
var fallbackIcon = {
  path: /* @__PURE__ */ jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
};
var Icon = forwardRef((props, ref) => {
  const {
    as: element,
    viewBox,
    color = "currentColor",
    focusable = false,
    children,
    className,
    __css,
    ...rest
  } = props;
  const _className = cx("chakra-icon", className);
  const customStyles = useStyleConfig("Icon", props);
  const styles = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color,
    ...__css,
    ...customStyles
  };
  const shared = {
    ref,
    focusable,
    className: _className,
    __css: styles
  };
  const _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  if (element && typeof element !== "string") {
    return /* @__PURE__ */ jsx(chakra.svg, { as: element, ...shared, ...rest });
  }
  const _path = children != null ? children : fallbackIcon.path;
  return /* @__PURE__ */ jsx(chakra.svg, { verticalAlign: "middle", viewBox: _viewBox, ...shared, ...rest, children: _path });
});
Icon.displayName = "Icon";

// ../../node_modules/@chakra-ui/icon/dist/chunk-DEQZ7DVA.mjs
import { forwardRef as forwardRef2 } from "@chakra-ui/system";
import { Children } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
function createIcon(options) {
  const {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options;
  const path = Children.toArray(options.path);
  const Comp = forwardRef2((props, ref) => /* @__PURE__ */ jsx2(Icon, { ref, viewBox, ...defaultProps, ...props, children: path.length ? path : /* @__PURE__ */ jsx2("path", { fill: "currentColor", d: pathDefinition }) }));
  Comp.displayName = displayName;
  return Comp;
}

// src/icons/create-icon.tsx
var createIcon2 = (props) => {
  return createIcon({
    viewBox: "0 0 24 24",
    defaultProps: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ...props
  });
};

// src/icons/icons.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ChevronUpIcon = createIcon2({
  displayName: "ChevronUpIcon",
  path: /* @__PURE__ */ jsx3("polyline", { points: "18 15 12 9 6 15" })
});
var ChevronDownIcon = createIcon2({
  displayName: "ChevronDownIcon",
  path: /* @__PURE__ */ jsx3("polyline", { points: "6 9 12 15 18 9" })
});
var ChevronLeftIcon = createIcon2({
  displayName: "ChevronLeftIcon",
  path: /* @__PURE__ */ jsx3("polyline", { points: "15 18 9 12 15 6" })
});
var ChevronRightIcon = createIcon2({
  displayName: "ChevronRightIcon",
  path: /* @__PURE__ */ jsx3("polyline", { points: "9 18 15 12 9 6" })
});
var HamburgerIcon = createIcon2({
  displayName: "ChevronDownIcon",
  path: /* @__PURE__ */ jsxs2("g", { fill: "none", children: [
    /* @__PURE__ */ jsx3("line", { x1: "3", y1: "12", x2: "21", y2: "12" }),
    /* @__PURE__ */ jsx3("line", { x1: "3", y1: "6", x2: "21", y2: "6" }),
    /* @__PURE__ */ jsx3("line", { x1: "3", y1: "18", x2: "21", y2: "18" })
  ] })
});
var CloseIcon = createIcon2({
  displayName: "CloseIcon",
  path: /* @__PURE__ */ jsxs2("g", { children: [
    /* @__PURE__ */ jsx3("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
    /* @__PURE__ */ jsx3("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
  ] })
});
var FilterIcon = createIcon2({
  displayName: "FilterIcon",
  path: /* @__PURE__ */ jsx3("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
});
var CalendarIcon = createIcon2({
  displayName: "CalendarIcon",
  path: /* @__PURE__ */ jsxs2("g", { children: [
    /* @__PURE__ */ jsx3("rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", ry: "2" }),
    /* @__PURE__ */ jsx3("line", { x1: "16", y1: "2", x2: "16", y2: "6" }),
    /* @__PURE__ */ jsx3("line", { x1: "8", y1: "2", x2: "8", y2: "6" }),
    /* @__PURE__ */ jsx3("line", { x1: "3", y1: "10", x2: "21", y2: "10" })
  ] })
});
var PlusIcon = createIcon2({
  displayName: "PlusIcon",
  path: /* @__PURE__ */ jsxs2("g", { children: [
    /* @__PURE__ */ jsx3("line", { x1: "12", y1: "5", x2: "12", y2: "19" }),
    /* @__PURE__ */ jsx3("line", { x1: "5", y1: "12", x2: "19", y2: "12" })
  ] })
});
var MinusIcon = createIcon2({
  displayName: "MinusIcon",
  path: /* @__PURE__ */ jsx3("g", { children: /* @__PURE__ */ jsx3("line", { x1: "5", y1: "12", x2: "19", y2: "12" }) })
});
var ViewOffIcon = createIcon2({
  displayName: "ViewOffIcon",
  path: /* @__PURE__ */ jsxs2("g", { children: [
    /* @__PURE__ */ jsx3("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }),
    /* @__PURE__ */ jsx3("line", { x1: "1", y1: "1", x2: "23", y2: "23" })
  ] })
});
var ViewIcon = createIcon2({
  displayName: "ViewOffIcon",
  path: /* @__PURE__ */ jsxs2("g", { children: [
    /* @__PURE__ */ jsx3("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
    /* @__PURE__ */ jsx3("circle", { cx: "12", cy: "12", r: "3" })
  ] })
});
var SearchIcon = createIcon2({
  displayName: "SearchIcon",
  path: /* @__PURE__ */ jsxs2("g", { children: [
    /* @__PURE__ */ jsx3("circle", { cx: "11", cy: "11", r: "8" }),
    /* @__PURE__ */ jsx3("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })
  ] })
});
var CheckIcon = createIcon2({
  displayName: "CheckIcon",
  path: /* @__PURE__ */ jsx3("g", { children: /* @__PURE__ */ jsx3("polyline", { points: "20 6 9 17 4 12" }) })
});

export {
  cx,
  createIcon2 as createIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  HamburgerIcon,
  CloseIcon,
  FilterIcon,
  CalendarIcon,
  PlusIcon,
  MinusIcon,
  ViewOffIcon,
  ViewIcon,
  SearchIcon,
  CheckIcon
};
//# sourceMappingURL=chunk-2NLF5BBK.mjs.map